<template>
  <div dir="rtl" class="min-h-screen relative flex items-center justify-center px-4 py-8  overflow-hidden">
    <div class="w-full max-w-md">
      <div class="glass-card rounded-3xl p-7 md:p-8">
        <div class="flex justify-center mb-6">
          <div class="relative">
            <div class="pointer-events-none absolute -inset-6 blur-2xl opacity-40
                        bg-gradient-to-r from-indigo-500/30 via-fuchsia-500/20 to-emerald-500/20"></div>
            <v-img
                src="/img/icons/exuni-logo.png"
                max-height="100"
                max-width="160"
            ></v-img>
          </div>
        </div>

        <!-- Username -->
        <div class="mb-4">
          <label class="block text-right text-slate-300 text-sm font-semibold mb-2">نام کاربری</label>
          <div class="relative">
            <input
                v-model="username"
                type="text"
                placeholder="نام کاربری"
                class="input-glass pr-4 pl-10"
                autocomplete="username"
            />
            <span class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </span>
          </div>
        </div>

        <!-- Password -->
        <div class="mb-2">
          <label class="block text-right text-slate-300 text-sm font-semibold mb-2">رمز عبور</label>
          <div class="relative">
            <input
                v-model="password"
                :type="pass_type"
                placeholder="رمز عبور"
                class="input-glass pr-4 pl-12"
                autocomplete="current-password"
                @keyup.enter="login"
            />

            <button
                @click="changeType"
                type="button"
                class="absolute left-2 top-1/2 -translate-y-1/2
                     h-9 w-9 rounded-xl border border-white/10 bg-white/5
                     flex items-center justify-center text-slate-300
                     hover:bg-white/10 hover:text-indigo-200 transition"
                aria-label="نمایش/مخفی کردن رمز"
            >
              <i :class="`fa ${pass_icon}`"></i>
            </button>
          </div>

          <div class="mt-2 flex items-center justify-between text-xs text-slate-400">
            <span class="inline-flex items-center gap-2">
              <span class="h-1.5 w-1.5 rounded-full bg-white/30"></span>
              رمز را با کسی به اشتراک نگذارید
            </span>
            <button type="button" class="hover:text-slate-200 transition">
              فراموشی رمز؟
            </button>
          </div>
        </div>

        <!-- Submit -->
        <div class="mt-6">
          <button
              @click="login"
              class="w-full py-3 rounded-2xl text-base font-extrabold text-white
                   bg-gradient-to-r from-indigo-600/90 via-purple-600/90 to-fuchsia-600/90
                   border border-white/10 shadow-lg shadow-black/30
                   hover:opacity-95 hover:scale-[1.01] active:scale-[0.99]
                   transition flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M14 2v6h6"/>
            </svg>
            ورود
          </button>
        </div>

        <!-- Foot -->
        <div class="mt-6 pt-4 border-t border-white/10 text-center text-xs text-slate-400">
          با ورود، شما قوانین و شرایط استفاده را می‌پذیرید.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixin from "@/views/auth/mixin";

export default {
  name: "Login",
  mixins: [AuthMixin],
  data() {
    return {
      username: "",
      password: "",
      pass_type: "password",
      pass_icon: "fa-eye",
      twoFactorAuthenticationDialog: "",
      twoFactorAuthenticationCode: "",
    };
  },
  mounted() {
    document.title = "ورود";
    if (this.token) {
      this.redirect();
    }
  },
  methods: {
    changeType() {
      this.pass_type = this.pass_type === "password" ? "text" : "password";
      this.pass_icon = this.pass_type === "password" ? "fa-eye" : "fa-eye-slash";
    },
    redirect() {
      let redirectUrl = this.urlQuery.redirectUrl;
      this.$router.push(redirectUrl || { name: "Home" });
    },
    login() {
      this.request({
        url: this.endpoint("login"),
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.twoFactorAuthenticationCode,
        },
        token: false,
        success: (data) => {
          if (data.need_two_factor_authentication) {
            this.twoFactorAuthenticationDialog = true;
          } else {
            this.twoFactorAuthenticationDialog = false;
            this.setToken(data.token);
            this.redirect();
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.glass-card{
  background: rgba(2, 6, 23, 0.58);
  border: 1px solid rgba(255,255,255,0.10);
  box-shadow: 0 24px 80px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.06);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  position: relative;
  overflow: hidden;
}
.glass-card::before{
  content:"";
  position:absolute;
  inset:0;
  pointer-events:none;
  background:
      radial-gradient(circle at 18% 12%, rgba(255,255,255,0.08), transparent 45%),
      linear-gradient(to bottom, rgba(255,255,255,0.06), transparent 35%);
}
.glass-card > *{ position:relative; z-index:1; }

.input-glass{
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 16px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.10);
  color: rgba(226,232,240,1);
  font-size: 14px;
  outline: none;
  transition: 150ms;
}
.input-glass::placeholder{ color: rgba(148,163,184,0.85); }
.input-glass:focus{
  border-color: rgba(99,102,241,0.55);
  box-shadow: 0 0 0 4px rgba(99,102,241,0.18);
}

button:focus { outline: none; }
</style>
